<ion-header *ngIf="isDesktop">
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content [scrollEvents]="true">
  
  <page-loader-comp *ngIf="!pageLoaded"></page-loader-comp>

  <bloc-header-comp *ngIf="isDesktop" [compOptions]="{
    'title': blocHeaderTitle,
    isBackBtn: true,
    url: 'conduite',
    loading: false
  }"></bloc-header-comp>
  <bloc-header-comp *ngIf="!isDesktop" [compOptions]="{
    'title': blocHeaderTitle,
    isBackBtn: true,
    url: 'conduite',
    withOutputClose: 'conduite',
    isDesktop: !isDesktop,
    loading: false
  }" (outputHeader)="triggerActionById($event)"></bloc-header-comp>

  <div [ngClass]="{'ion-content-container max-width-600': isDesktop, 'display-none': !pageLoaded, 'reset-page-fx': resetPageFx}">
    <div class="lesson-notation" [ngClass]="{'evs-card-ui': isDesktop}">
      <h3 *ngIf="isDesktop">Ta leçon avec {{lessonToRate.teacherName}}</h3>
      <h4 *ngIf="!isDesktop">Ta leçon avec {{lessonToRate.teacherName}}</h4>
      <div class="lesson-infos">
        <div class="teacher-picture" #teacherPicture></div>
        <div class="lesson-data">
          <div class="no-wrap">{{lessonToRate.date}}</div>
          <div>{{lessonToRate.horaire}}</div>
          <div>{{lessonToRate.location}}</div>
        </div>
      </div>
      <div class="bloc-notation">
        <h4>Comment s'est passée ta leçon&nbsp;?</h4>
        <div class="notes">
          <div *ngFor="let i of utils.numberToArray(5)" class="note" [ngClass]="{'active': userNotation === (i+1)}" (click)="setUserNotation(i+1)">{{i+1}}</div>
        </div>
        <div class="legends">
          <span>Très mal passée</span>
          <span>Très bien passée</span>
        </div>
      </div>
      <div class="bloc-tags">
        <h4>Pour quelle(s) raison(s)&nbsp;?</h4>
        <div class="tags">
          <div *ngFor="let tag of tags" class="tag" (click)="addUserTag(tag)" [ngClass]="{'active': userTags.includes(tag)}">{{tag}}</div>
        </div>
      </div>
      <div class="bloc-commentaires">
        <h4>Commentaire général</h4>
        <form class="evs-form">
          <div>
            <!-- <textarea *ngIf="isDesktop" name="comments" rows="1" id="comments" placeholder="N'hésite pas à laisser un commentaire plus complet" [(ngModel)]="userComments"></textarea> -->
            <textarea name="comments" rows="5" id="comments" (keyup)="checkUserComment()" [(ngModel)]="userComments"></textarea>
            <label for="comments" [ngClass]="{'label-up': userComments !== ''}">N'hésite pas à nous laisser un commentaire sur ta leçon</label>
          </div>
          <div *ngIf="needComment" class="field-error">La note étant inférieure à 4, ajoute un commentaire<br>(10 caractères minimum)</div>
        </form>
        <div class="margin-top-8 margin-bottom-16 text-left clear-float">
          <!-- <input type="checkbox" name="anonymous" id="anonymous" value="1" [(ngModel)]="isAnonymous"> -->
          <div class="checkboxes" (click)="setCheckbox('anonymous')">
            <span class="inline-block">
              <img *ngIf="!isAnonymous" src="assets/svg/checkbox.svg" height="18" alt="EnVoitureSimone">
              <img *ngIf="isAnonymous" src="assets/2022/icons/checkbox-on.svg" height="18" alt="EnVoitureSimone">
            </span>
            <span class="inline-block text-left">Publier en tant qu'anonyme</span>
          </div>
        </div>
        <div class="small-text text-left">En cochant cette case, nous nous engageons à ne pas transmettre ton nom à l’enseignant concerné.</div>
      </div>
      <div class="text-center margin-top-16">
        <button class="btn wpi-280" [disabled]="!canSubmit" (click)="sendNotation()">Valider</button>
      </div>
    </div>
  </div>

</ion-content>

<ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>